var map = {
	"./branded-asset@2x.png": 3188,
	"./digital-toolkits@2x.png": 9804,
	"./document-repository@2x.png": 525,
	"./dulux-academy@2x.png": 9175,
	"./focus-of-the-month@2x.png": 4821,
	"./help-videos@2x.png": 419,
	"./industry-events@2x.png": 1820,
	"./industry-insights@2x.png": 1521,
	"./knowledge-base@2x.png": 1280,
	"./new-product-development@2x.png": 1562,
	"./newsletter-repository@2x.png": 3281,
	"./rebate-scheme@2x.png": 6726,
	"./think-forward/npd@2x.png": 2226,
	"./video-training@2x.png": 8849,
	"./webshop@2x.png": 4733,
	"./work-smarter/work-smarter@2x.png": 417
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7186;